import React, { Suspense } from 'react';
import { IFootballLiveScore } from '@sky-it-livedata/livedata-sports-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const FootballWrapper = React.lazy(() => import('./football'));
export interface IDynamicFootball extends IComponentModel<IFootballLiveScore> {
  live?: boolean;
  model: any;
}

const DynamicFootball: React.FC<IDynamicFootball> = ({
  /* istanbul ignore next: default value */ model = {},
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicFootball) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <FootballWrapper
      live={live}
      initialModel={validateModel(model) as IFootballLiveScore}
      query={validateModel(query)}
    />
  </Suspense>
);

DynamicFootball.defaultProps = {
  live: false,
};

export default DynamicFootball;
